<template>
  <div>
    <pc-header ></pc-header>
    <div class="container">
      <div class="row">
        <div class="col">
          <h4 class="mt-5">Password recovery</h4>
          <div v-if="step === 'step1'" class="mt-2 text-secondary">Please enter your email. We will send recovery instructions if account exists.</div>
          <el-form v-if="step === 'step1'" ref="form" class="mt-4" label-width="120px" style="max-width: 500px">
            <el-form-item label="E-Mail">
              <el-input v-model="email"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" v-loading="loading" :disabled="!email" @click="startPasswordReset">Continue</el-button>
            </el-form-item>
          </el-form>
          <div v-if="step === 'step2'" class="text-secondary mt-2 ml-4">Please check your mailbox for further instructions</div>
          <div class="mt-5 text-secondary">Still cannot access your account? Please contact support team at:</div>
          <div class="mt-1"><a href="mailto:support@pycrunch.com">support@pycrunch.com</a></div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import axios from 'axios'

  import PcHeader from '../components/pc-header.component'
  import {track} from '../ga-events'
  import config from '../config'

  export default {
    components: {PcHeader},
    name: 'pc-reset-password',
    data () {
      return {
        email: '',
        step: 'step1',
        loading: false,
      }
    },
    methods: {
      async startPasswordReset () {
        track('my_profile', 'reset_password', this.email)
        this.loading = true

        try {
          let response = await axios.post(config.api_root + '/api/reset-password', {email: this.email})
          this.$alert('Password reset instructions sent to email ' + this.email, 'Password Recovery', {
            confirmButtonText: 'OK',
          });
          this.step = 'step2'
        } catch (e) {
          this.$alert('There was an error while trying to reset password. Contact support for assistance if the problem persists.', 'Password Recovery', {
            confirmButtonText: 'OK',
          });
        }
        finally {
          this.loading = false
        }
      },
    },
  }
</script>

<style scoped>

</style>